export const data = [{
    "name": "ChitChat",
    "img": "https://res.cloudinary.com/dofk7cu8i/image/upload/v1709274967/ChitChat_e4o2qg.png",
    "description": "Developed a real- time communication app, highlighting full-stack knowledge with innovative features for instant connectivity.Demonstrated proficiency in front - end and back - end development, applying user - centric design for a seamless user experience.",
    "link": "https://chitchat12.netlify.app/",
    "github": "https://github.com/vatsalagarwall?tab=repositories"
}, {
    "name": "Expenzify",
    "img": "https://media.istockphoto.com/id/1324801888/vector/production-efficiency-icon-vector-costs-optimization-symbol-for-graphic-design-logo-web-site.jpg?s=612x612&w=0&k=20&c=FJ1_t6qNSLF9jR5aCHzdb_UnU0wEIGMZyhTyJi6ee44=",
    "description": "A comprehensive expense tracking and management app that simplifies the process of recording, categorizing, and reporting your expenses.",
    "link": "https://expenzify.vercel.app/",
    "github": "https://github.com/vatsalagarwall/expenzify"
}, {
    "name": "Fresco",
    "img": "https://logowik.com/content/uploads/images/fresco6300.jpg",
    "description": "Optimized restaurant website for enhanced user experience, featuring interactive menus, efficient table reservations, and promotions. Improved customer engagement with streamlined online services.",
    "link": "https://fresco12.netlify.app/",
    "github": "https://github.com/vatsalagarwall/fresco-github"
}]